import React from "react";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch } from "react-redux";
import { actionCreators } from "../redux/DemographicsSagas";
import PropTypes from "prop-types";

const Filters = ({
  options,
  selectedFilters,
  name,
  label,
  selectAllText,
  allSelectedPlaceholder,
  numberDisplayed,
  includeFilter = true,
  includeSelectAll = true,
  enableOnly = true,
  enableDefaultSelected = true
}) => {
  const dispatch = useDispatch();
  return (
    <div className="select-box-no-width categories">
      <p>{label}</p>

      <MultiSelectDropdown
        allSelectedPlaceholder={allSelectedPlaceholder}
        selectAllText={selectAllText}
        filterType="Custom Range"
        options={options}
        height={375}
        includeFilter={includeFilter}
        numberDisplayed={numberDisplayed}
        selectedFilters={selectedFilters}
        includeSelectAll={includeSelectAll}
        enableOnly={enableOnly}
        enableDefaultSelected={enableDefaultSelected}
        haveOnSelectChange={false}
        updateLocations={(data) => dispatch(actionCreators.updateSelectedFilter({ data, name }))}
      />
    </div>
  );
};

Filters.propTypes = {
  options: PropTypes.array,
  selectedFilters: PropTypes.any,
  name: PropTypes.string,
  label: PropTypes.string,
  selectAllText: PropTypes.string,
  allSelectedPlaceholder: PropTypes.string,
  numberDisplayed: PropTypes.number,
  includeFilter: PropTypes.bool,
  includeSelectAll: PropTypes.bool,
  enableOnly: PropTypes.bool,
  enableDefaultSelected: PropTypes.bool
};

export default React.memo(Filters);
